import { RegionalPriceType } from './regional-price.type';

export interface StepupInfo {
  stepsUpId: number;
  name: string;
  description: string;
  isPublished: boolean;
  startDate: string;
  endDate: string;
  imageUrl: string;
  launchTimes: number;
  slotTimer: number;
  updatedAt: string;
  createdAt: string;
}

export interface LatestStepUpResponse {
  data: Partial<StepupInfo>;
}

export type Price = Record<string, number | undefined> & {
  USD?: number;
};

export interface AnalyticsItem {
  itemName?: string;
  quantity?: string | number;
  itemID?: string;
  shardID?: string;
}

export enum OfferCardTypeEnum {
  SINGLE3 = 'Single3',
  SINGLE2 = 'Single2',
  SINGLE1 = 'Banner',
}

interface OfferItemImages {
  url?: string;
  resizeUrl?: string;
}

export interface OfferItem {
  itemID: string;
  itemName?: string;
  quantity?: string | number;
  url?: string;
  images?: OfferItemImages;
}
export interface FactionGiftItemsProps {
  itemID: string;
  itemName?: string;
  quantity?: string | number;
  url?: string;
  label?: string;
}
export interface DripOfferData {
  b0?: number;
  b1?: string[]; // Drip items
  b3?: string;
  b5?: string;
  b6?: string;
  b7?: string;
}
export interface OfferData {
  AlternativeCostAmount?: number;
  AlternativeCostID?: string;
  StoreItemDescription?: string;
  HardCurrencyPackageID?: string;
  Global_Offer?: boolean;
  StockMax?: number;
  SubsPurchase?: unknown[];
  DiscountPercentage?: number;
  SkipEndScaling?: boolean;
  ServerScaling?: string;
  IsClicked?: boolean;
  EndDate?: string;
  GiftSubject?: string;
  Bonus3?: string;
  Gifts?: unknown;
  Platform_Type?: string;
  PortalAvailability?: boolean;
  SubscriptionRequired?: string;
  gate?: string;
  CombinationType?: string;
  ShowInStore?: boolean;
  HighlightOfferCount?: number;
  Version?: string;
  StoreItemName?: string;
  OfferDescriptionText?: string;
  StartDate?: string;
  IsNested?: boolean;
  EventCarousel_ID?: string;
  Magnet?: boolean;
  OfferWeight?: number;
  StoreItemTagline?: string;
  schedules?: Array<Array<boolean | string>>;
  OfferType?: string;
  OfferSectionID?: string;
  StockQuantity?: number;
  ShowStock?: boolean;
  OffersID: string;
  Bonus1?: string;
  Featured?: boolean;
  Bonus2?: string;
  Bonus5?: string;
  Bonus4?: string;
  Bonus7?: string;
  Bonus6?: string;
  Bonus9?: string;
  Bonus8?: string;
  StoreItemImage?: string;
  GiftMessage?: string;
  OfferDisplayID?: string;
  Availability?: string;
  OfferItemContent?: string[];
  OfferItemImage?: string[];
  OfferItemImageResize?: string[];

  analyticsItems?: AnalyticsItem[];
  OfferBackgroundImage?: string;
  OfferBackgroundImageResize?: string;
  OfferItemTexts?: string[];
  LayoutType?: string;
  Price?: Price;
  InitialPrice?: Price;
  defaultCurrency?: string;
  XsollaID?: string;
  StrikeThroughPrice?: number;
  BonusPercentage?: number;
  categoryId?: string;
  status?: number | string;
  Web_StepUp?: boolean;
  VipPoint?: number;
  badgeType?: string;
  badgeIcon?: string;
  badgeText?: string;
  offerItems?: OfferItem[];
  OfferItemTypes?: string[];
  factionGiftItems?: FactionGiftItemsProps[];
  position?: number;
  isDailyOffer?: boolean;
  dc?: DripOfferData;
  regionalPrice?: RegionalPriceType;
}

export interface OfferSectionResponse {
  sectionId: string;
  sectionBackgroundColor: string;
  sectionHeaderColor: string;
  sectionSubTitle: string;
  sectionTexture?: string;
  sectionTitle: string;
  sectionTooltip: string;
  sectionWeight: number;
  sectionData: unknown;
  updatedAt: string;
  createdAt: string;
}

export interface SectionOffer {
  offers: OfferData[];
  section?: OfferSectionResponse;
}

export interface OfferByIdResponse {
  data: {
    offerData: OfferData;
  };
}

export interface StockResponse {
  data: {
    OffersID: string;
    StockQuantity: number;
  }[];
}

export interface RedeemCouponXsollaData {
  items: OfferData[];
  externalId: string;
  rewardType: 'xsolla';
}

export interface PlaygamiResolvedItem {
  itemID: string;
  itemName: string;
  quantity: number;
  images: {
    resizeUrl: string;
    url: string;
  };
}

export interface RedeemCouponPlaygamiData {
  rewardContent: Record<string, number>;
  resolvedItems: PlaygamiResolvedItem[];
  rewardType: 'playgami';
}

export interface RedeemCouponResponse {
  data: RedeemCouponXsollaData | RedeemCouponPlaygamiData;
}

export interface CurrencyData {
  id: number;
  name: string;
  rate: number;
  isActive: boolean;
  typeId: number;
  globalType: number;
}
export interface CurrencyResponse {
  data: CurrencyData[];
}

export type SegmentedOffers = {
  [variation: string]: string;
} & {
  OfferAll?: string;
  OfferVarsFieldList?: string;
  NonLogin?: string;
};

export interface SegmentedOffersResponse {
  success: boolean;
  data: {
    offers: string[];
  };
}

export interface ConsolidatedOffersQuery {
  categories?: string;
  countryCode?: string;
}

export interface ConsolidatedOffersResponse {
  statusCode: number;
  status: string;
  error: number;
  message: string;
  data: {
    special?: SectionOffer[];
    webCoinDaily?: SectionOffer[];
    rewards?: SectionOffer[];
    daily?: SectionOffer[];
    cashPacks?: SectionOffer[];
    webCoins?: SectionOffer[];
    rubies?: SectionOffer[];
    tournament?: SectionOffer[];
    featured?: SectionOffer[];
    clubCoins?: SectionOffer[];
  };
}

export interface CouponData extends OfferData {
  offerId: string | string[];
  quantity: number;
}

export enum CategoryEnum {
  SPECIAL = 'special',
  WEBCOIN_DAILY = 'webCoinDaily',
  REWARDS = 'rewards',
  DAILY = 'daily',
  CASH_PACKS = 'cashPacks',
  WEB_COINS = 'webCoins',
  RUBIES = 'rubies',
  TOURNAMENT = 'tournament',
  FEATURED = 'featured',
  CLUB_COINS = 'clubCoins',
}

export type CategoryType = `${CategoryEnum}`;

export interface ActiveDripOffer {
  offer_id: string;
  total_days: number;
  next_day: number;
  claimed_days: number[];
  can_claim_now: boolean;
  is_complete: boolean;
  available_at: number;
  expiry_ts: number;
  streak: number;
  offer_data: OfferData | null;
}
